// import Vue from 'vue';
import _ from 'lodash';
import {
    STORE_CHOSEN_ITEM, // 选择商品-确认
    EDIT_STORE_ITEM_PROPS,
    INIT_STORE_CHOSEN_GOODS, // 初始化选择商品
    INIT_STORE_CHOSEN_GOODS_IDS, // 初始化选择商品IDS
} from '../mutationTypes';

const state = {
    chosenIds: [],
    chosenGoods: [],
};

const mutations = {
    [INIT_STORE_CHOSEN_GOODS](state) { // 初始化选择商品
        state.chosenGoods = [];
    },
    [INIT_STORE_CHOSEN_GOODS_IDS](state) { // 初始化选择商品IDS
        state.chosenIds = [];
    },
    [STORE_CHOSEN_ITEM](state, { chosenGoods, type}) { // 选择商品-确认,type 1出库 入库
        state.chosenIds = _.map(chosenGoods, 'goodsId');
        if (type === 1) { // 入库
            state.chosenGoods = _.map(state.chosenIds, (id) => {
                const index = _.findIndex(chosenGoods, { goodsId: id });
                return Object.assign({}, {
                    goodsId: chosenGoods[index].goodsId,
                    goodsName: chosenGoods[index].goodsName,
                    goodsBrand: chosenGoods[index].goodsBrand,
                    specification: chosenGoods[index].specification,
                    enterRepertory: chosenGoods[index].enterRepertory ? chosenGoods[index].enterRepertory : 1, // 入库数量
                });
            });
        } else if (type === 2) { // 出库
            state.chosenGoods = _.map(state.chosenIds, (id) => {
                const index = _.findIndex(chosenGoods, { goodsId: id });
                return Object.assign({}, {
                    goodsId: chosenGoods[index].goodsId,
                    goodsName: chosenGoods[index].goodsName,
                    goodsBrand: chosenGoods[index].goodsBrand,
                    specification: chosenGoods[index].specification,
                    goodsPrice: chosenGoods[index].goodsPrice,
                    // 出库单价-默认商品售价
                    setPrice: chosenGoods[index].setPrice ? chosenGoods[index].setPrice : chosenGoods[index].goodsPrice,
                    repertory: Number(chosenGoods[index].repertory),  // 可用库存数量
                    outRepertory: chosenGoods[index].outRepertory ? chosenGoods[index].outRepertory : 1, // 出库数量
                });
            });
        }
    },
    [EDIT_STORE_ITEM_PROPS](state, { id, k, val }) { // goodsId，键名，键值 修改数量 售价
        const itemIndex = _.findIndex(state.chosenGoods, { goodsId: id });
        state.chosenGoods[itemIndex][k] = val;
    },
};

export const actions = {};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/storeGoods.js